<nz-form-item class="label-on-top">
  @if (label) {
    <nz-form-label [nzRequired]="isRequired(control)"> {{ label }} </nz-form-label>
  }
  <nz-form-control nzHasFeedback [nzErrorTip]="errorTemplate" [nzValidateStatus]="control">
    @if (showCopy) {
      <div class="copy-group">
        <ng-container *ngTemplateOutlet="selectTemplate"></ng-container>
        <span
          class="ant-input-group-addon copy-addon"
          [class.copy-addon-empty]="!copyText()"
          title="Copy"
          (click)="copyValue()"
        >
          <i nz-icon [nzType]="copied ? 'check' : 'copy'"></i>
        </span>
      </div>
    } @else {
      <ng-container *ngTemplateOutlet="selectTemplate"></ng-container>
    }
  </nz-form-control>
  <ng-template #errorTemplate>
    {{ control.errors | formError }}
  </ng-template>
</nz-form-item>

<ng-template #selectTemplate>
  <nz-select
    style="width: 100%"
    [nzPlaceHolder]="placeholder"
    [nzDisabled]="isDisabled"
    [formControl]="control"
    class="mt-2"
    [nzMode]="multiSelection ? 'multiple' : 'default'"
    [nzSize]="size"
    (ngModelChange)="selectionChanged($event)"
    [nzShowSearch]="true"
    [nzPlacement]="placement"
  >
    <nz-option
      *ngFor="let option of options"
      [nzLabel]="option[optionsLabel]"
      [nzValue]="option[optionsValue]"
    ></nz-option>
  </nz-select>
</ng-template>
